export default __webpack_public_path__ + "static/media/what-is-raven.0cc00616.svg";